<template>
    <div v-if="initDataLoaded">
        <v-layout row wrap>
            <!-- <v-flex xs12 sm2 px-1>
                <v-text-field 
                    v-model="searchParams.num" 
                    label="Quote #"
                    ></v-text-field>
            </v-flex>
            <v-flex xs12 sm2 px-1>
                <v-text-field 
                    v-model="searchParams.facilityName" 
                    label="Facility Name"
                    ></v-text-field>
            </v-flex>
            <v-flex xs6 sm2 px-1>
                <v-text-field 
                    v-model="searchParams.dateFrom" 
                    label="Date From"
                    hint="mm/dd/yyyy"
                    ></v-text-field>
            </v-flex>
            <v-flex xs6 sm2 px-1>
                <v-text-field 
                    v-model="searchParams.dateTo" 
                    label="Date To"
                    hint="mm/dd/yyyy"
                    ></v-text-field>
            </v-flex>
            <v-flex xs12 sm2 px-1 v-show="allLookups.regions">
                <v-select
                :items="allLookups.regions"
                item-text="name"
                item-value="id"
                v-model="searchParams.regionId"
                label="Region"
                hint=""
                persistent-hint
                >
                </v-select>
            </v-flex>
            <v-flex xs12 sm2 px-1 v-show="allLookups.territories">
                <v-select
                :items="allLookups.territories"
                item-text="name"
                item-value="id"
                v-model="searchParams.territoryId"
                label="Territory"
                hint=""
                persistent-hint
                >
                </v-select>
            </v-flex>
            <v-flex xs12 px-1>
                <v-layout wrap>
                    <v-flex py-1 my-0
                        xs12 sm6 md4 lg2
                        v-for="item in allLookups.statuses" :key="item.id">
                        <v-checkbox 
                            class="py-1 my-0"
                            color="green"
                            v-model="searchParams.qtStatuses" :label="item.name" :value="item.id"></v-checkbox>
                    </v-flex>
                </v-layout>
            </v-flex> -->
            <!-- <v-flex xs12 px-1>
                <v-select
                :items="allLookups.statuses"
                item-text="name"
                item-value="id"
                v-model="searchParams.qtStatuses"
                label="Status"
                multiple
                chips
                hint=""
                persistent-hint
                ></v-select>
            </v-flex> -->

            <v-flex xs12 sm4 px-1>
                <v-select
                :items="allLookups.salesReps"
                item-text="name"
                item-value="id"
                v-model="searchParams.salesRepId"
                label="Sales Rep."
                hint=""
                persistent-hint
                >
                </v-select>
            </v-flex>

            <v-flex xs12 sm4 px-1 v-show="allLookups.csReps">
                <v-select
                :items="allLookups.csReps"
                item-text="name"
                item-value="id"
                v-model="searchParams.csRepId"
                label="Customer Service Rep."
                hint=""
                persistent-hint
                ></v-select>
            </v-flex>
            <!-- <v-flex xs12 sm4 text-xs-center>
                <v-btn color="primary" @click.prevent="searchQuotes">Submit</v-btn>
            </v-flex> -->
        </v-layout>
        <!-- {{getUserDefaultQuoteSearchCriteria()}}
        {{userQuoteSearchParams}} -->
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    props: ['defaultRows'],
    data () {
        return {
            allLookups: null,
            searchParams: null,
            foundSearchParamsInState: false, //why need this? if searchParams loaded from state, we will not change page to 1
        }
    },
    computed: {
        ...mapGetters('auth', [
            'userHasPublicRole',
            'userHasSalesQuoteManagerRole'
        ]),
        ...mapGetters('pubQuoteSearch', [
            'userQuoteSearchParams'
        ]),
        initDataLoaded () {
            return this.allLookups && this.searchParams
        },
    },
    methods: {
        ...mapActions('pubQuoteSearch', [
            'getUserDefaultQuoteSearchCriteria',
            'getUserDefaultQuoteSearchLookups',
        ]),
        searchQuotes () {
            if(this.searchParams) {
                // console.log('kkkkl')
                if(!this.foundSearchParamsInState) {
                    this.searchParams.page = 1
                } else {
                    this.foundSearchParamsInState = false
                }
                this.$emit('onSearchParamsChanged', this.searchParams)

            }
        }
    },
    watch: {
        searchParams: {
            handler: function (newVal, oldVal) {
                this.searchQuotes()
            },
            deep: true
        },
    },
    async created () {
        //this.searchParams = this.userQuoteSearchParams
        this.searchParams = await this.getUserDefaultQuoteSearchCriteria()
        // if (!this.searchParams) {
        //     this.searchParams = await this.getUserDefaultQuoteSearchCriteria()
        // }
        // else {
        //     this.foundSearchParamsInState = true
        // }

        this.allLookups = await this.getUserDefaultQuoteSearchLookups()
        // add an extra all item
        if(this.allLookups.csReps && this.allLookups.csReps.length > 1) {
            this.allLookups.csReps = [{id: null, name: 'All'}, ...this.allLookups.csReps]
        }
        if(this.allLookups.salesReps && this.allLookups.salesReps.length > 1) {
            if(this.userHasSalesQuoteManagerRole) {
                this.allLookups.salesReps = this.allLookups.salesReps

            } else {
                this.allLookups.salesReps = [{id: null, name: 'All'}, ...this.allLookups.salesReps]

            }
        }
        if(this.allLookups.regions && this.allLookups.regions.length > 1) {
            this.allLookups.regions = [{id: null, name: 'All'}, ...this.allLookups.regions]
        }
        if(this.allLookups.territories && this.allLookups.territories.length > 1) {
            this.allLookups.territories = [{id: null, name: 'All'}, ...this.allLookups.territories]
        }

        //init search
        this.searchQuotes()
    },

}
</script>
